<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Instellingen
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        placeholder="Zoek..."
        append-icon="fas fa-search"
        single-line
        hide-details
        @keyup="searchKeyUp()"
      ></v-text-field>
      <v-btn
        class="ml-4"
        depressed
        color="primary"
        @click="newClick"
        disabled
      >
    <v-icon
      small
      left
    >fas fa-folder-plus</v-icon>
    Nieuw
    </v-btn>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50] }"
      :loading="isSearching"
      @click:row="rowClick"
    >

    </v-data-table>

    <v-dialog
      v-model="dialog"
      max-width="700"
      persistent
    >
      <v-card>
        <v-toolbar color="title" dark flat short class="px-2">
          <v-toolbar-title>Instelling</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="mt-12">
          <v-form @submit.prevent>

            <v-text-field
              outlined
              v-model="model.description"
              readonly
              label="Omschrijving"
            ></v-text-field>

            <v-text-field
              outlined
              v-model="model.value"
              :error-messages="errors.value"
              label="Waarde"
              :suffix="model.unit"
            ></v-text-field>

          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            outlined
            depressed
            @click="dialog = false"
          >Annuleren</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="saveClick()"
          >Opslaan</v-btn>
        </v-card-actions>


      </v-card>





    </v-dialog>

  </v-card>
  
</template>

<script>
import { inject, ref } from '@vue/composition-api'
import { debounce } from 'lodash'

export default {
  components: {
  },
  setup() {
    const api = inject('api')
    const loader = inject('loader')

    const settingCollection = api.resource('settings').collection({
      rules: {
        query: 'query:description',
      }
    })

    const { items, filter, totalCount, options, isSearching } = settingCollection

    const headers = [
      { text: 'Omschrijving', value: 'description' },
      { text: 'Waarde', value: 'value' },
    ]

    const dialog = ref(false)

    const settingModel = api.resource('settings', { debug: true }).model()
    const { attributes: model, errors, isBusy } = settingModel

    loader.bindRef(isBusy)

    function newClick() {
      settingModel.clear()
      dialog.value = true
    }

    function rowClick(item) {
      settingModel.find(item.id).then(() => {
        dialog.value = true
      })
    }

    function saveClick() {
      settingModel.save().then(() => {
        settingCollection.search()
        dialog.value = false
      })
    }

    function deleteClick(id) {
      api.resource('suppliers').remove(id).then(() => {
        settingCollection.search()
      })
    }

    const searchKeyUp = debounce(settingCollection.search, 300)

    return {
      headers,
      items,
      filter,
      searchKeyUp,
      totalCount,
      options,
      isSearching,
      newClick,
      rowClick,
      saveClick,
      deleteClick,
      dialog,
      model,
      errors,
    }

  },
}
</script>


<style scoped>

::v-deep .v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover {
  cursor: pointer;
}

</style>
